import { render, staticRenderFns } from "./MonthlyTaxHSBC.vue?vue&type=template&id=fb47205a"
import script from "./MonthlyTaxHSBC.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxHSBC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports